import React, { FC } from 'react'
import { SiteMapYearV4DTO } from '@west-australian-newspapers/publication-types'
import {
    StyledYearList,
    StyledYearIndex,
    StyledYear,
    StyledMonths,
    StyledMonth,
    StyledMonthLink,
} from '../SiteMap.styled'

interface SiteMapYearProps {
    siteMapIndex: SiteMapYearV4DTO
}

export const SiteMapYears: FC<SiteMapYearProps> = ({ siteMapIndex }) => {
    return (
        <StyledYearList>
            {siteMapIndex.years.map((yearEntry) => (
                <StyledYearIndex key={yearEntry.year}>
                    <StyledYear>{yearEntry.year}</StyledYear>
                    <StyledMonths>
                        {yearEntry.months.map((month) => (
                            <StyledMonth key={month}>
                                <StyledMonthLink
                                    to={`/sitemap/${yearEntry.year}/${month}`}
                                >
                                    {new Intl.DateTimeFormat('en-US', {
                                        month: 'long',
                                    }).format(new Date(0, month - 1))}
                                </StyledMonthLink>
                            </StyledMonth>
                        ))}
                    </StyledMonths>
                </StyledYearIndex>
            ))}
        </StyledYearList>
    )
}
